export default {
      id: "gear-usage",
      viewBox: "0 0 18 18",
      url: "/" + "img/marilyn-ui.svg#gear",
      toString: function () {
        return this.url;
      }
    }